import { z } from 'zod';
import { Block, BlockSchema } from './Block.types';

import { BlockType, CTABlockConfigSchema } from './blockConfig/Types';

export const CTABlockSchema = BlockSchema.extend({
  blockConfig: CTABlockConfigSchema,
});
export type CTABlock = z.infer<typeof CTABlockSchema>;

export function isCTABlock(block: Block) {
  return block.blockConfig.type === BlockType.Cta;
}
